import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {sorterNum} from 'Utils'
import {Table, Input} from 'antd'
import {timeFormat} from 'd3-time-format'

import style from './style.sass'

@inject('store') @observer
class Transactions extends Component {
  search = (e) => {
    this.props.store.backtest.tables.filterTable(e.target.value)
  }
  changePage = (page) => {
    this.props.store.backtest.tables.fetchTransactions(this.props.id, page.current)
  }
  downloadCsv = () => {
    this.props.store.backtest.tables.saveFile('transactions', this.props.id, 'csv')
  }
  downloadXlsx = () => {
    this.props.store.backtest.tables.saveFile('transactions', this.props.id, 'xlsx')
  }
  render() {
    let columns = [{
      title: 'Date',
      dataIndex: 'date',
      render: value => timeFormat('%Y-%m-%d')(new Date(value)),
      sorter: (a, b) => new Date(a.date) - new Date(b.date)
    }, {
      title: 'Ticker',
      dataIndex: 'ticker',
      sorter: (a, b) => a.ticker.localeCompare(b.ticker)
    }, {
      title: 'Transaction',
      dataIndex: 'action',
      sorter: (a, b) => a.action.localeCompare(b.action)
    }, {
      title: 'Amount',
      dataIndex: 'amount',
      sorter: (a, b) => sorterNum(a.amount, b.amount)
    }, {
      title: 'Price',
      dataIndex: 'price',
      sorter: (a, b) => sorterNum(a.price, b.price)
    }]
    const {backtest} = this.props.store
    if (backtest.current && backtest.current.has_intraday_timeframe) {
      const col = {
        title: 'Time',
        dataIndex: 'date',
        key: 'time',
        render: value => timeFormat('%H:%M')(new Date(value))
      }
      columns.splice(1,0,col)
    }
    const {count, size, page, loading} = backtest.tables.transactions
    return(
      <div styleName='wrapper'>
        <div className='card-box'>
          <div styleName='table-controls'>
            <div styleName='buttons'>
              <button onClick={this.downloadCsv}>Download CSV</button>
              <button onClick={this.downloadXlsx}>Download XLSX</button>
            </div>
            <Input onChange={this.search} placeholder='Search' styleName='search'/>
          </div>
          <Table
            onChange={this.changePage}
            style={{margin: '6px 0'}}
            dataSource={backtest.tables.filteredTransactions}
            columns={columns}
            size='small'
            loading={loading}
            pagination={{
              pageSize: size,
              total: count,
              current: page
            }}
            locale={loading ? {
              emptyText: 'Loading'
            } : {
              emptyText: 'No Data'
            }}
          />
        </div>
      </div>
    )
  }
}

export default Transactions
